import { Controller } from "stimulus";
import { formValidator } from "../components/form-validator";

export default class extends Controller {
  static targets = [
    "group"
  ];

  validate(e, group) {
    if(group !== null) {
      if(this.validator.validate({group: group})) {
        return true;
      }
    } else {
      if(this.validator.validate()) {
        return true;
      }
    }
    e.preventDefault();
    return false;
  }

  asyncValidate(e, group, callback) {
    if(group !== null) {
      this.validator.whenValidate({group: group}).done(callback)
    } else {
      this.validator.whenValidate().done(callback)
    }
  }

  reset(e) {
    this.element.querySelectorAll("input,select,textarea").forEach(input => {
      if (input.type === "hidden") {
        return;
      }
      if (input.type === "checkbox") {
        input.checked = false;
        return;
      }
      input.value = "";
    });
  }

  connect() {
    this.validator = formValidator(this.element)
    // １つのフォームで分割してバリデーションをかけたい場合のために
    // group target毎にdata-parsley-groupを追加する
    // validateの前処理として毎回実行したほうが動的なHTMLの変更に強くなるかも
    this.groupTargets.forEach(group => {
      const groupName = group.dataset.group;
      group.querySelectorAll("input,select,textarea").forEach(input => {
        input.setAttribute("data-parsley-group", groupName);
      });
    });
  }
}
